import { observable, flow, makeObservable } from "mobx";

import * as labelsApi from "@/hooks/labels";
import { appStore } from "../";

export interface Label {
    id: number
    label_group?: LabelGroup
    name: string
    school_id?: string
    is_archived: boolean
}

export interface LabelGroup {
    id: number
    name: string
    ordering: number
    labels: Label[]
}

class LabelStore {

    @observable isProcessing = false;
    @observable labels: Label[] = [];
    @observable labelGroups: LabelGroup[] = [];
    @observable label: Label;

    constructor() {
        makeObservable(this);
    }

    @flow
    *fetchLabels (): any {
        this.isProcessing = true;
        try {
            this.labels = yield labelsApi.fetchLabels();

        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

    @flow
    *fetchLabel (labelId: string): any {
        try {
            this.label = yield labelsApi.fetchLabel(Number(labelId));
        } catch(e) {
            appStore.addError(e);
        }
    }

    @flow
    *createLabel (label: {name: string, label_group: number}): any {
        this.isProcessing = true;
        try {
            yield labelsApi.createLabel(label);
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

    @flow
    *updateLabel (label: Label, changes: Partial<Label>): any {
        this.isProcessing = true;
        try {
            yield labelsApi.updateLabel(label, changes);
            this.isProcessing = false;
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

    @flow
    *deleteLabel (labelId: number): any {
        this.isProcessing = true;
        try {
            yield labelsApi.deleteLabel(labelId);
            this.isProcessing = false;
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

    @flow
    *fetchLabelGroups (): any {
        this.isProcessing = true;
        try {
            this.labelGroups = yield labelsApi.fetchLabelGroups();
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

    @flow
    *createLabelGroup(data: {name: string, order?: number}): any {
        this.isProcessing = true;
        try{
            yield labelsApi.createLabelGroup(data);
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

    @flow
    *updateLabelGroup(group: LabelGroup, data: Partial<LabelGroup>): any {
        this.isProcessing = true;
        try{
            yield labelsApi.updateLabelGroup(group, data);
        } catch(e){
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

    @flow
    *deleteLabelGroup(groupId: number): any {
        this.isProcessing = true;
        try {
            yield labelsApi.deleteLabelGroup(groupId);
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

}

export { LabelStore };